<template>
  <el-form label-width="160px" @submit.native.prevent>
    <div v-show="!isCollapsed">

      <!-- <el-form-item label="排序">
        <el-input v-model="form.Sort" type="number" step="1" min="0"></el-input>
      </el-form-item> -->

      <!-- <el-form-item label="產地商品">
        <div class="w-100">
          <el-select style="width: 100%;" filterable v-model="form.ProductIDs" :multiple="true" placeholder="請選擇商品">
            <template slot="empty">
              <p class="el-select-dropdown__empty">沒有資料</p>
            </template>
            <el-option
              v-for="item in activeProducts"
              :key="'product-'+item.ID"
              :label="item.Tw.Name"
              :value="item.ID">
            </el-option>
          </el-select>
        </div>
      </el-form-item> -->
      <el-form-item label="商品標籤">
        <div class="w-100">
          <el-select style="width: 100%;" filterable v-model="form.TagID" placeholder="請選擇商品">
            <template slot="empty">
              <p class="el-select-dropdown__empty">沒有資料</p>
            </template>
            <el-option
              v-for="item in activeProductTags"
              :key="item.ID"
              :label="item.TitleTw"
              :value="item.ID">
            </el-option>
          </el-select>
        </div>
        <!-- <p class="hint">選取相對應標籤後，前台會自動顯示該標籤所有商品</p> -->
      </el-form-item>

      <el-form-item label="水果">
        <div class="w-100">
          <el-select style="width: 100%;" filterable v-model="form[formKey].ProductIDs" :multiple="true" placeholder="請選擇水果">
            <template slot="empty">
              <p class="el-select-dropdown__empty">沒有資料</p>
            </template>
            <el-option
              v-for="item in tags"
              :key="'originInfoProduct-'+item.ID"
              :label="item['Name'+formKey]"
              :value="item.ID">
            </el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item label="國家">
        <el-select class="w-100" v-model="form.Country" placeholder="請選擇國家">
          <el-option label="台灣" value="taiwan"/>
          <el-option label="日本" value="japan"/>
          <el-option label="其他" value="other"/>
        </el-select>
      </el-form-item>

      <el-form-item label="產地名稱">
        <el-input v-model="form[formKey].Title" @input="onTitleInput"></el-input>
      </el-form-item>

      <el-form-item label="描述">
        <el-input v-model="form[formKey].Description" type="textarea" autosize></el-input>
      </el-form-item>

          <el-form-item label="圖片">
            <el-upload
              v-loading="isProcessingImage"
              ref="elupload"
              accept="image/*"
              class="el-upload-images"
              drag
              action
              :multiple="true"
              :auto-upload="true"
              :http-request="onImageHTTPRequest">
              <i class="el-icon-upload"></i>
              <!-- <div class="el-upload__text">
                將文件拖曳至此，或
                <em>點擊上傳</em>
              </div> -->
            </el-upload>

            <draggable v-model="form[formKey].Images"
              handle=".drag-target-img">
              <div v-for="(obj,idx) in form[formKey].Images" :key="`car-image-info-${idx}`" v-show="!obj.DeletedAt"
                class="img-wrapper">
                <img class="drag-target-img" :src="getImageURL(obj)"/>
                <el-button @click.stop="confirmDeleteImage(idx)" type="danger" icon="el-icon-close" size="mini" circle></el-button>
              </div>
            </draggable>

            <br>
            <p class="hint">建議上傳 1920x1080的圖片，以獲得最佳畫面呈現。可拖曳圖片排序。</p>
          </el-form-item>

      <el-form-item label="地圖圖片">
        <el-upload
          v-loading="isProcessingMapImage"
          ref="eluploadmap"
          accept="image/svg+xml"
          class="el-upload-images"
          drag
          action
          :auto-upload="true"
          :http-request="e => processImageFile(e, genCoverImageFileParam())">
          <img
            ref="coverImg"
            v-show="form[formKey]['coverObjectURL'] || form[formKey].MapImageURL"
            class="preview"
            @load="e => onImageLoaded(e, genCoverImageFileParam())"
            :src="form[formKey]['coverObjectURL'] || form[formKey].MapImageURL"
            style="max-width: 100%;max-height: 120px;"/>
          <i v-show="!(form[formKey].MapImageURL || form[formKey]['coverObjectURL'])" class="el-icon-upload"></i>
          <!-- <div class="el-upload__text">
            將文件拖曳至此，或
            <em>點擊上傳</em>
          </div> -->
        </el-upload>

        <!-- <img v-for="(img,idx) in form[formKey].imagesJsonArr" :key="`originInfo-${formKey}-image-${idx}`"
          class="img-images"
          @dblclick="confirmDeleteImage(idx)"
          :src="img['@1']"/>
        <br> -->
        <p class="hint">請上傳 1080x1080的svg圖片檔案，請使用Chrome瀏覽器上傳。</p>
      </el-form-item>

    </div>

    <!-- <div style="padding-left: 120px;">
      <div v-show="isCollapsed">詳細資訊</div>

      <el-divider>
        <i v-show="!isCollapsed" class="clickable el-icon-arrow-up" @click="isCollapsed=true">收起</i>
        <i v-show="isCollapsed" class="clickable el-icon-arrow-down" @click="isCollapsed=false">展開</i>
      </el-divider>

      <content-editor v-model="form[formKey].contentJsonArr" />
    </div> -->

    <origin-info-product-editor-modal :isShow="isShowProductAddeditModal" @close="isShowProductAddeditModal = false" @submitted="onProductAdded"/>

  </el-form>
</template>

<script>
import moment from 'moment'
import Config from '@/assets/js/config.js'
// import ContentEditor from '@/utils/content-editor/components/ContentEditor.vue'
import OriginInfoProductEditorModal from '@/data/originInfoProduct/view/editor-modal.vue'
import MixinProcessImageFile from '@/utils/mixin-process-image-file.vue'
import draggable from 'vuedraggable'
import ImageThumbnailer from '@/utils/ImageThumbnailer.js'
export default {
  mixins: [MixinProcessImageFile],
  components: {
    // ContentEditor,
    OriginInfoProductEditorModal,
    draggable
  },
  props: {
    form: {
      default: () => {
        return {}
      }
    },
    formKey: {
      default: ''
    }
  },
  data: () => {
    return {
      isCollapsed: false,
      isShowProductAddeditModal: false,
      // discount image
      isProcessingMapImage: false
    }
  },
  computed: {
    activeProductTags () {
      return this.$store.state.productTag.list.filter(o => o.IsActive)
    },
    activeProducts () {
      return this.$store.state.product.list.filter(o => o.IsActive && !o.TeamBuyingID)
    },
    tags () {
      return this.$store.state.originInfoProduct.list
    },
    isEdit () {
      return this.$route.name !== 'createOriginInfo'
    }
  },
  methods: {
    getImageURL (obj) {
      return this.getAbsoluteURL(obj.ImageURLX1 || obj.ImageURLX2 || obj.ImageURLX3)
      // return `${Config.WEBURL}/webimage/${obj.URLKey}`
    },
    getAbsoluteURL (s) {
      if (!s) return s
      if (s.startsWith('/')) return Config.WEBURL + s
      return s
    },
    onProductAdded (tag) {
      this.form.ProductID = tag.ID
      // this.toggleProduct(tag.ID)
    },
    openProductCreatorModal () {
      this.isShowProductAddeditModal = true
    },
    // tag
    // toggleProduct (id) {
    //   let idx = this.form[this.formKey].ProductIDs.findIndex(o => o === id)
    //   if (idx >= 0) {
    //     this.form[this.formKey].ProductIDs.splice(idx, 1)
    //   } else {
    //     this.form[this.formKey].ProductIDs.push(id)
    //   }
    // },
    async onImageHTTPRequest (e) {
      let isImg = e.file.type.indexOf('image') >= 0
      if (!isImg) return this.$message({ message: `請上傳圖片檔案`, type: 'error' })

      this.$refs.elupload.clearFiles()

      // 1. 壓縮成兩個尺寸
      let requiredSize = { w: 1920, h: 1080 }
      let compressOptions = [
        {
          maxWidth: requiredSize.w,
          maxHeight: requiredSize.h
        },
        {
          maxWidth: requiredSize.w * 2 / 3,
          maxHeight: requiredSize.h * 2 / 3
        },
        {
          maxWidth: requiredSize.w / 3,
          maxHeight: requiredSize.h / 3
        }
      ]

      let compressPromiseList = []
      for (let opts of compressOptions) {
        let promise = new Promise((resolve, reject) => {
          ImageThumbnailer.shared.requestCompress(
            e.file,
            blob => {
              resolve(blob)
            },
            opts
          )
        })
        compressPromiseList.push(promise)
      }
      Promise.all(compressPromiseList).then(results => {
        onThumb(results)
      })
      // 2 上傳圖片
      let uploadPathPrefixList = [
        this.isEdit
          ? `origin-info-/${this.form.ID}/image-`
          : `origin-info-/image@3x-${this.form.NameTw}-`,
        this.isEdit
          ? `origin-info-/${this.form.ID}/image-`
          : `origin-info-/image@2x-${this.form.NameTw}-`,
        this.isEdit
          ? `origin-info-/${this.form.ID}/image-`
          : `origin-info-/image-@1x-${this.form.NameTw}-`
      ]
      const onThumb = (blobs) => {
        // 上傳圖片
        uploadBlobs(blobs)
      }

      const uploadBlobs = (blobs) => {
        this.isProcessingImage = true

        let uploadPromiseList = []
        for (var i = 0; i < blobs.length; ++i) {
          let pathPrefix = uploadPathPrefixList[i]

          let promise = this.$services.firebase.upload(
            blobs[i],
            pathPrefix
          )
          uploadPromiseList.push(promise)
        }

        Promise.all(uploadPromiseList).then(urls => {
          onImageUploaded(urls)
        })
      }
      // 3. 上傳後callback 顯示圖片
      const onImageUploaded = (urls) => {
        this.isProcessingImage = false
        if (!this.form[this.formKey].Images) this.form[this.formKey].Images = []
        this.form[this.formKey].Images.push({
          // SavedAt: moment().format(),
          ImageURLX1: urls[2],
          ImageURLX2: urls[1],
          ImageURLX3: urls[0]
        })
      }
    },
    // cover image
    genCoverImageFileParam () {
      let requiredSize = { w: 1080, h: 1080 }
      // 當我們上傳圖片後，
      let params = {
        'isProcessingImageKey': 'isProcessingMapImage',
        // 要求使用者應該要使用的尺寸
        'requiredSize': requiredSize,
        // element-ui el-upload，用於清除檔案
        'elUploadRefKey': 'eluploadmap',
        // 上傳該圖片後，要顯示該圖片，並在onLoad時抓取該圖片尺寸
        'imgRefKey': 'coverImg',
        // 要上傳的表單 form
        'formObject': this.form[this.formKey],
        // 呼應 imgRefKey，圖片壓縮後，createObjectURL，並顯示該圖片，並暫存紀錄該URL
        'blobObjectURLKey': 'coverObjectURL',
        // 每一張圖片在要上傳時 form 的欄位
        'imageURLFormKeys': [
          'MapImageURL'
          // 'CoverImageURLX2',
          // 'MapImageURL'
        ],
        // 每一張圖片要壓縮的比例
        'compressOptions': [
          {
            maxWidth: requiredSize.w,
            maxHeight: requiredSize.h
          }
          // {
          //   maxWidth: requiredSize.w * 2 / 3,
          //   maxHeight: requiredSize.h * 2 / 3
          // },
          // {
          //   maxWidth: requiredSize.w / 3,
          //   maxHeight: requiredSize.h / 3
          // }
        ],
        // 每一張圖片暫存的blob，確認沒問題後才會上傳
        'blobObjKeys': [
          'coverImageBlob@3x'
          // 'coverImageBlob@2x',
          // 'coverImageBlob@1x'
        ],
        // 每一張圖片上傳的路徑
        'uploadPathPrefixList': [
          this.isEdit
            ? `originInfo/${this.form.ID}/cover-`
            : `originInfo/cover@3x-${this.form[this.formKey].Name}-`
          // this.isEdit
          //   ? `originInfo/${this.form.ID}/cover-`
          //   : `originInfo/cover@2x-${this.form[this.formKey].Name}-`,
          // this.isEdit
          //   ? `originInfo/${this.form.ID}/cover-`
          //   : `originInfo/cove-@1x-${this.form[this.formKey].Name}-`
        ],
        // 上傳後 callback
        onImageUploaded: () => {
          console.log(`onImageUploaded`, this.form, this.form[this.formKey])
          // let newImg = {
          //   '@3': this.form[this.formKey].CoverImageURLX3,
          //   '@2': this.form[this.formKey].CoverImageURLX2,
          //   '@1': this.form[this.formKey].MapImageURL
          // }
          // if (!this.form[this.formKey].imagesJsonArr) {
          //   this.$set(this.form[this.formKey], 'imagesJsonArr', [newImg])
          // } else {
          //   this.form[this.formKey].imagesJsonArr = [newImg]
          //   // this.form[this.formKey].imagesJsonArr.push(newImg)
          // }
          // this.form[this.formKey].CoverImageURLX3 = ''
          // this.form[this.formKey].CoverImageURLX2 = ''
          // this.form[this.formKey].MapImageURL = ''
        }
      }
      return params
    },
    confirmDeleteImage (idx) {
      if (window.confirm('確定刪除此圖片?')) {
        if (this.form[this.formKey].Images[idx].ID && this.form[this.formKey].Images[idx].ID > 0) {
          this.form[this.formKey].Images[idx].DeletedAt = moment().format()
          this.form[this.formKey].Images[idx].DeletedBy = this.$store.state.admin.ID
        } else {
          this.form[this.formKey].Images.splice(idx, 1)
        }
      }
    },
    onTitleInput () {
      // this.form[this.formKey].Name = this.form[this.formKey].Name.replace(/"/g, '')
      // this.form[this.formKey].Name = this.form[this.formKey].Name.replace(/#/g, '')
      // this.form[this.formKey].Name = this.form[this.formKey].Name.replace(/\//g, '')
      this.$emit('title-changed', this.form[this.formKey].Name)
    }
  },
  created () {
    this.form[this.formKey].contentJsonArr = this.form[this.formKey].Contents
      ? JSON.parse(this.form[this.formKey].Contents)
      : []
  }
}
</script>

<style>
.discount-wrapper {
  margin-top: 30px;
  padding: 25px 84px 25px 0;
  background-color: rgb(247, 247, 247);

  align-items: center;
  display: inline-flex;
}

.el-upload-discount {
  height: 90px;
  display: inline-block;
}

.el-upload-discount .el-upload-dragger {
  width: 90px;
  height: 90px;
}

.el-upload-discount .el-upload__text {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.46;
  letter-spacing: normal;
  text-align: center;
  color: rgb(112, 112, 112);
}

.el-upload-images {
  height: 100px;
  float: left;
  display: inline-block;
}

.el-upload-images .el-upload-dragger {
  width: 100px;
  height: 100px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.el-upload-images .el-icon-upload {
  margin: 0 !important;
}

.img-images {
  width: 100px;
  height: 100px;
  display: inline-block;
  float: left;
  margin-left: 15px;
}

.hint {
  display: block;
  width: 100%;
  float: left;
  text-align: left;
  font-size: 12px;
  font-weight: bold;
  color: #666;
}
</style>

<style scoped>

.img-wrapper {
  width: 100px;
  height: 100px;
  display: inline-block;
  float: left;
  margin-left: 15px;
  position: relative;
  cursor: pointer;
}
.img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.is-cover .cover-hint {
  display: block;
}
.img-wrapper .el-button {
  position: absolute;
  top: -5px;
  right: -5px;
  cursor: pointer;

  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cover-hint {
  display: none;
  position: absolute;
  top: -5px;
  left: -5px;
  background-color: cornflowerblue;
  width: 2.5em;
  height: 1.5em;
  color: white;
  padding: 0;
  line-height: 1.5em;
}
</style>
